import { render, staticRenderFns } from "./indexShopKf.vue?vue&type=template&id=ad039444"
import script from "./indexShopKf.vue?vue&type=script&lang=js"
export * from "./indexShopKf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports